// CartIntermediateContext.ts
import { createContext } from 'react'

import { type CartIntermediateContextValue } from '../model/CartIntermediateContextValue'

export const CartIntermediateContext = createContext<
  CartIntermediateContextValue | undefined
>(undefined)
